import React from "react";

import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import {Checkbox, FormControlLabel} from "@mui/material";
import {eachDayOfInterval, isValid} from "date-fns";
import {INDETERMINATE} from "./usePriceSummarizer";

const days = [
    {attributeName: "monday", label: "L"},
    {attributeName: "tuesday", label: "M"},
    {attributeName: "wednesday", label: "M"},
    {attributeName: "thursday", label: "G"},
    {attributeName: "friday", label: "V"},
    {attributeName: "saturday", label: "S"},
    {attributeName: "sunday", label: "D"},
];

export const dayAttributeNames = days.map((day) => day.attributeName);

const TabArrivalDeparture = ({formik, height = 475}) => {
    const dateFrom = formik.values.dateFrom;
    const dateTo = formik.values.dateTo;

    let availableDays = [];
    if (isValid(dateFrom) === true && isValid(dateTo) === true) {
        availableDays = dateFrom - dateTo > 7 * 24 * 60 * 60 * 1000 ?
            days.map((day) => day.attributeName) :
            eachDayOfInterval({start: dateFrom, end: dateTo}).map((d) => d.toLocaleDateString("en-US", {weekday: "long"}).toLowerCase());
    }

    const disabled = days.map((day) => availableDays.includes(day.attributeName) === false);

    return <Stack direction="column" spacing={4} mt={2} height={height}>
        <Typography>
            Seleziona i giorni in cui la struttura accetta arrivi e partenze. Esempio: se selezioni
            il sabato e la domenica come giorni di arrivo, la struttura accetterà arrivi solo il
            sabato e la domenica.
        </Typography>

        <Typography>
            Giorni adibiti agli arrivi:
        </Typography>

        <Stack direction="row" justifyContent="space-evenly">
            {
                days.map((day, i) => (
                    <FormControlLabel
                        key={day.attributeName}
                        control={
                            <Checkbox
                                name={`checkin[${day.attributeName}]`}
                                color="primary"
                                checked={formik.values.checkin[day.attributeName] === INDETERMINATE ? false : !!formik.values.checkin[day.attributeName]}
                                indeterminate={formik.values.checkin[day.attributeName] === INDETERMINATE}
                                disabled={disabled[i]}
                                onChange={(e) => {
                                    // cannot use formik.handleChange because it does not work as expected with indeterminate
                                    formik.setFieldValue(`checkin[${day.attributeName}]`, e.target.checked)
                                }}
                                />
                        }
                        label={day.label}
                        labelPlacement="top"
                        sx={{margin: 0}}
                    />
                ))
            }
        </Stack>
        <Typography>
            Giorni adibiti alle partenze:
        </Typography>
        <Stack direction="row" justifyContent="space-evenly">
            {
                days.map((day, i) => (
                    <FormControlLabel
                        key={day.attributeName}
                        control={
                            <Checkbox
                                name={`checkout[${day.attributeName}]`}
                                color="primary"
                                checked={formik.values.checkout[day.attributeName] === INDETERMINATE ? false : !!formik.values.checkout[day.attributeName]}
                                indeterminate={formik.values.checkout[day.attributeName] === INDETERMINATE}
                                disabled={disabled[i]}
                                onChange={(e) => {
                                    // cannot use formik.handleChange because it does not work as expected with indeterminate
                                    formik.setFieldValue(`checkout[${day.attributeName}]`, e.target.checked)
                                }}
                            />
                        }
                        label={day.label}
                        labelPlacement="top"
                        sx={{margin: 0}}
                    />
                ))
            }
        </Stack>
    </Stack>
}

export default TabArrivalDeparture;